/**
 * Lyd- og haptikkservice for navigasjonsvarsler.
 * Bruker Web Audio API for syntetiserte toner — ingen lydfiler kreves.
 */

let audioCtx: AudioContext | null = null;

function getAudioContext(): AudioContext | null {
  if (audioCtx && audioCtx.state !== 'closed') return audioCtx;
  try {
    audioCtx = new AudioContext();
    return audioCtx;
  } catch {
    return null;
  }
}

/**
 * Resume AudioContext etter brukerinteraksjon (kreves av nettlesere).
 * Kall denne ved f.eks. knappeklikk under onboarding/start navigasjon.
 */
export function resumeAudioContext(): void {
  const ctx = getAudioContext();
  if (ctx?.state === 'suspended') ctx.resume().catch(() => {});
}

function playTone(frequency: number, duration: number, type: OscillatorType = 'sine', volume = 0.3): void {
  const ctx = getAudioContext();
  if (!ctx) return;
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});

  const osc = ctx.createOscillator();
  const gain = ctx.createGain();

  osc.type = type;
  osc.frequency.setValueAtTime(frequency, ctx.currentTime);
  gain.gain.setValueAtTime(volume, ctx.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + duration);

  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(ctx.currentTime);
  osc.stop(ctx.currentTime + duration);
}

/** Off-route varselslyd: to synkende toner */
export function playOffRouteAlert(): void {
  playTone(880, 0.15, 'triangle', 0.4);
  setTimeout(() => playTone(660, 0.2, 'triangle', 0.35), 180);
}

/** Tilbake på ruten: to stigende toner */
export function playBackOnRouteAlert(): void {
  playTone(523, 0.12, 'sine', 0.3);
  setTimeout(() => playTone(784, 0.15, 'sine', 0.3), 140);
}

/** Nærmer seg POI: mjuk pling */
export function playNearbyPoiAlert(): void {
  playTone(1047, 0.1, 'sine', 0.2);
}

/** Haptics — vibrer enheten hvis støttet */
export function vibratePattern(pattern: number | number[]): void {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    try { navigator.vibrate(pattern); } catch {}
  }
}
